import api from './index'
import { axios } from '@/utils/request'

export function createActor(parameter) {
  return axios({
    url: api.BaseURL + api.Conversation + 'create' + api.Actor,
    method: 'POST',
    data: parameter
  })
}

export function getListActor(parameter) {
  return axios({
    url: api.BaseURL + api.Conversation + 'list' + api.Actor,
    method: 'GET',
    params: parameter
  })
}

export function getDetailActor(parameter) {
  return axios({
    url: api.BaseURL + api.Conversation + 'detail' + api.Actor,
    method: 'GET',
    params: parameter
  })
}

export function updateActor(parameter) {
  return axios({
    url: api.BaseURL + api.Conversation + 'update' + api.Actor,
    method: 'POST',
    data: parameter
  })
}

export function deleteActor(parameter) {
  return axios({
    url: api.BaseURL + api.Conversation + 'delete' + api.Actor,
    method: 'POST',
    data: parameter
  })
}